export default function TestimonialSection() {
  return (
    <section id="faq" className="bg-background-50 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
          ( What Our Users Say )
        </h2>

        <div className="inline-flex items-center gap-2 bg-foreground-950 text-background-50 px-4 py-1.5 rounded-full text-sm font-semibold mb-8">
          <i className="ri-star-fill text-accent-400 text-sm"></i>
          <span>4.9 / 5.0</span>
        </div>

        <blockquote className="mb-8">
          <p className="font-heading text-lg md:text-xl text-foreground-800 leading-relaxed italic">
            "AllChinaBuySpreadsheet completely changed how I approach product sourcing. What used to take me an entire weekend now takes less than two hours. The supplier comparison feature alone has saved me thousands in bad sourcing decisions. If you are serious about dropshipping, this is the tool you need."
          </p>
        </blockquote>

        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-full bg-secondary-300 flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20business%20owner%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20background%2C%20friendly%20confident%20expression%2C%20modern%20casual%20style&width=100&height=100&seq=avatar-reviewer-unique&orientation=squarish"
              alt="User avatar"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="text-left">
            <p className="text-foreground-950 font-semibold text-sm">Marcus R.</p>
            <p className="text-foreground-500 text-xs">Dropshipper, 3+ Years Experience</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2">
          <button className="w-9 h-9 rounded-lg border border-background-300 flex items-center justify-center text-foreground-500 hover:border-foreground-400 hover:text-foreground-700 transition-colors duration-300 cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button className="w-9 h-9 rounded-lg bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors duration-300 cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}